import React from 'react';

const Arco = ({ lado }) => (
  <svg className={`guia-btn__arc guia-btn__arc--${lado}`} viewBox="0 0 16 52" aria-hidden="true">
    <path d={lado === 'l' ? 'M 14 0 C -2 14 -2 38 14 52' : 'M 2 0 C 18 14 18 38 2 52'} />
  </svg>
);

/**
 * Button — GUIA
 * Principal: el texto entre dos arcos "( BOTÓN )". Sólido: píldora rellena.
 * El contenido de TODO botón va en MAYÚSCULAS (lo hace el CSS; no escribas
 * las mayúsculas a mano).
 * Al hacer click pasa unos instantes al color complementario (Orquídea↔Brote)
 * y un anillo se abre como cuando una piedra se hunde en el agua.
 *
 * @param {'principal'|'solido'} variant
 */
export default function Button({ variant = 'principal', children, className = '', onClick, disabled, ...props }) {
  const [hundido, setHundido] = React.useState(false);
  const timer = React.useRef(null);
  React.useEffect(() => () => clearTimeout(timer.current), []);

  const handleClick = (e) => {
    setHundido(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setHundido(false), 900);
    onClick?.(e);
  };

  return (
    <button
      type="button"
      className={`guia-btn ${variant === 'solido' ? 'guia-btn--solido' : ''} ${className}`.trim()}
      data-hundido={hundido}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      {variant !== 'solido' && <Arco lado="l" />}
      <span>{children}</span>
      {variant !== 'solido' && <Arco lado="r" />}
    </button>
  );
}
